import { expertService } from "../_services"
import { ExpertCourt } from "../pages/admin/expert/models/ExpertCourt.model"
import { ExpertRegion } from "../pages/admin/expert/models/ExpertRegion.model"
import { PersonaType } from '../models/payment.order.form.models'
import { QrCodeLogItem } from "../pages/admin/expert/models/QrCodeLogItem.model"

export default {
  namespaced: true,

  state: {
    regions: [],
    region: new ExpertRegion(),
    qrCodeImg: null,
    personaType: null,
    caseType: null,
    isSber: null,
    logList: [],
    pagination: {
      totalItems: 0,
      size: 0,
      totalPages: 0,
      pagesLoaded: 0
    }
  },

  getters: {
    hasRegions: ({ regions }) => !!regions.length,
    regionHasCourt: ({ regions }) => (id) => !!regions.find(region => region.id == id)?.courtCards?.length,
    getRegionById: ({ regions }) => (id) => regions.find(region => region.id == id),
    sortedCourts: ({ region }) => region?.courtCards?.sort((a, b) => a.type.value < b.type.value) ?? []
  },

  mutations: {
    setPersonaType: (state, value) => {
      state.personaType = value
    },

    setQRCodeImg: (state, value) => {
      state.qrCodeImg = value
    }
  },

  actions: {
    fetchRegions: ({ state }) => {
      expertService.getRegions().then(regions => {
        state.regions = regions?.map(region => new ExpertRegion(region)) ?? []
      })
    },

    fetchRegionByAlias: ({ state }, alias) => {
      state.region = new ExpertRegion()
      return expertService.getRegion(alias).then(region => {
        state.region = new ExpertRegion(region)
        return false
      }).catch(error => {
        return error
      })
    },

    saveCourtRegion: ({ state }, payload) => {
      expertService.saveCourtRegion(payload).then(region => {
        if (payload.id != region.id) state.regions.push(new ExpertRegion(region))
      })
    },

    deleteRegion: ({ state }, id) => {
      expertService.deleteRegion(id).then(() => {
        state.regions.forEach((item, index) => {
          if (item.id == id) state.regions.splice(index, 1)
        })
      })
    },

    saveCourt: ({ state }, payload) => {
      expertService.saveCourt(payload.court).then(court => {
        if (payload.court.id != court.id) {
          state.regions.find(region => region.id == payload.regionId).courtCards.push(new ExpertCourt(court))
        }
      })
    },

    deleteCourt: ({ state }, payload) => {
      expertService.deleteCourt(payload.id).then(() => {
        const region = state.regions.find(region => region.id == payload.regionId)
        region.courtCards.forEach((item, index) => {
          if (item.id == payload.id) region.courtCards.splice(index, 1)
        })
      })
    },

    getQrCode: ({ state }, payload) => {
      if (payload.personaType == PersonaType.FL.value) {
        state.caseType = payload?.caseType ?? null
        state.isSber = payload?.sber ?? null
        expertService.getQrCode(payload).then((data) => {
          state.qrCodeImg = URL.createObjectURL(data)
        })
      }
    },

    getBankInfo: ({ state }, bic) => {
      state
      if (!bic) return
      return expertService.getBankInfo(bic).then((data) => {
        return data
      })
    },

    getPaymentOrder: ({ state }, form) => {
      state
      return expertService.getPaymentOrder(form).then((data) => {
        return data
      })
    },

    getPaymentOrderForUL: ({ state }, form) => {
      state
      return expertService.getPaymentOrderForUL(form).then((data) => {
        return data
      })
    },

    getQrCodeLog: ({ state }) => {
      state
      return expertService.getQrCodeLog().then(data => {
        return data
      })
    },

    getQrCodeLogByPage: ({ state }, pageNumber) => {
      return expertService.getQrCodeLogByPage(pageNumber).then(data => {
        state.logList = state.logList.concat(data.content.map(item => new QrCodeLogItem(item)))
        state.pagination.size = data.size
        state.pagination.totalItems = data.totalElements
        state.pagination.totalPages = data.totalPages
        state.pagination.pagesLoaded++
      })
    }
  }
}